import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/simp_in/step2';
import { CTRL_DATE } from '../../../validators/DATE/ctrlDate';
import { CTRL_1086 } from '../../../validators/horsDef/1086/ctrl1086';
import { CTRL_1087 } from '../../../validators/horsDef/1087/ctrl1087';
import { CTRL_1120 } from '../../../validators/horsDef/1120/ctrl1120';
import { CTRL_416HorsDef } from '../../../validators/horsDef/416/ctrl416_horsDef';
import { TypeProcFNS } from '../models/TypeProcFNS';
import { SimpINControlNames } from '../simpINControleNames';
@Component({
	selector: 'app-type-procFNS',
	templateUrl: './type-procFNS.component.html'
})
export class TypeProcFNSComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeProcFNS';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() procedure: TypeProcFNS;

	public readonly procedureAdapteeOValue = 'procedureAdapteeO';
	public readonly procedureAdapteeRValue = 'procedureAdapteeR';

	public radioButtonValue: string;
	public radioButtonCtrlName: string;

	public step2 = new Step2();
	public rg1 = CTRL_1120.id + '_1';
	public rg2 = CTRL_1086.id + '_1';
	public rg3 = CTRL_1087.id + '_1';
	public rg4 = CTRL_DATE.id + '_1';
	public rg5 = CTRL_416HorsDef.id + '_1';

	constructor() {}

	public ngOnInit() {
		if (this.procedure.procedureAdapteeO === '') {
			this.radioButtonValue = this.procedureAdapteeOValue;
		}
		else if (this.procedure.procedureAdapteeR === '') {
			this.radioButtonValue = this.procedureAdapteeRValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_procedureAdapteeO';
		this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_1120Names_json() }));
		this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_1086Names_json() }));
		this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_1087Names_json() }));
		//this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_DATENames_json() }));
		this.parentForm.addControl(this.getStepId() + this.rg5, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_416Names_json() }));
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getUidVarientes() {
		return this.getUid() + '_SepSep_' + 'variantes';
	}

	getUidAttributionSansNegociation() {
		return this.getUid() + '_SepSep_' + 'attributionSansNegociation';
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}
}
